import Label from "components/shared/form/Label";
import React from "react";
import Hint from "components/shared/fields/Hint";
import { Control, Controller } from "react-hook-form";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/pro-light-svg-icons";

type CSVInputArgs = {
  name: string;
  label: string;
  control?: Control;
  required?: boolean;
  hint?: string;
  disabled?: boolean;
};
export default function CSVInput({
  name,
  label,
  required,
  hint,
  disabled,
  control,
}: CSVInputArgs) {
  return (
    <div className="control-group">
      {label && <Label label={label} required={!!required} />}
      <div className="controls border-box p-3">
        <Controller
          name={name}
          control={control}
          rules={{
            required,
          }}
          render={({ field }) => {
            return (
              <div className="flex gap-2 items-center">
                <label className="btn btn-light mr-2">
                  {I18n.t("js.files.add_file")}
                  <input
                    className="hidden"
                    type="file"
                    onChange={(e) => {
                      field.onChange(e.target.files);
                    }}
                    accept=".csv"
                    disabled={disabled}
                    aria-label={label}
                  />
                </label>
                {field.value && field.value.length > 0 && (
                  <div className="flex gap-2 items-center truncate">
                    <FontAwesomeIcon
                      icon={faFileCsv}
                      className={classNames(
                        "file-type file-type-csv text-2xl muted",
                      )}
                    />
                    <span className="text-muted truncate">
                      {field.value[0].name}
                    </span>
                  </div>
                )}
              </div>
            );
          }}
        />

        {hint && <Hint hint={hint} />}
      </div>
    </div>
  );
}
